import { useElementVisibility, ELEMENTS } from './useIsElementVisible.ts';
import { useContentLabels } from './useContentLabels.ts';

export const useCanEditLabels = () => {
	const { isElementVisible } = useElementVisibility();
	const { data } = useContentLabels();
	const { hasEditPermissions } = data;
	return {
		isLabelsAvailable: isElementVisible(ELEMENTS.ROWS.LABELS),
		canEditLabels: hasEditPermissions,
	};
};
